module.exports = __webpack_public_path__ + "img/nacc-logo.67fdbb8f.jpg";